import { mdiArrowLeft } from '@mdi/js';
import { useNavigate } from 'react-router-dom';

import HeaderButton from '../components/layout/HeaderButton';
import Layout from '../components/layout/Layout';
import CredentialProofRequestList from '../features/credential/CredentialProofRequestList';

/**
 * @description Wallet proof requests page component
 * @return {React.FC}
 */
const WalletProofRequests = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Layout
      title="Proof Requests"
      leftButton={<HeaderButton icon={mdiArrowLeft} onPress={() => navigate('/')}></HeaderButton>}
      scrollViewProps={{
        minHeight: '100%'
      }}>
      <CredentialProofRequestList />
    </Layout>
  );
};

export default WalletProofRequests;
